// initial state
const baseName = '/admin/api/map'

const mapUpDevice = baseName + '/upDevice'
const mapUpLocation = baseName + '/upLocation'
const mapSearchDevice = baseName + '/searchDevice'
const mapTrsearch= baseName + '/trsearch'
const a = Object.assign({mapUpDevice, mapUpLocation,mapSearchDevice,mapTrsearch})
export default a
